/**
 * Decodes a JWT token and returns the payload
 * @param token - The JWT token string
 * @returns The decoded payload object, or null if decoding fails
 */
export const decodeJWT = (token: string): Record<string, unknown> | null => {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) {
      console.error('Invalid JWT token format');
      return null;
    }

    // Decode the payload (second part)
    const payload = parts[1];
    // Replace URL-safe base64 characters and add padding if needed
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
    
    const decodedPayload = JSON.parse(atob(padded));
    return decodedPayload;
  } catch (error) {
    console.error('Error decoding JWT token:', error);
    return null;
  }
};

/**
 * Extracts the user role from a JWT token
 * @param token - The JWT token string
 * @returns The user role string, or null if not found or decoding fails
 */
export const extractUserInfo = (token: string): Record<string, unknown> | null => {
  const payload = decodeJWT(token);
  return payload;
};

